import type { ChoiceOptionItem } from '~/presentation/ui';
import type { ExportFormat } from './types';

import { IExportFormat } from './types';

export const EXPORT_REPORT_OPTIONS: ChoiceOptionItem<ExportFormat>[] = [
  {
    label: 'Comma Separated Values (CSV)',
    value: IExportFormat.CSV,
    description: 'Useful for Excel, Numbers, or other spreadsheet programs.',
  },
  {
    label: 'Extensible Markup Language (XML)',
    value: IExportFormat.XML,
  },
  {
    label: 'JSON Lines (JSONL)',
    value: IExportFormat.JSONL,
  },
  {
    label: 'Apache Parquet',
    value: IExportFormat.PARQUET,
  },
];
